const REQUEST_TOPIC_LANDING = '@@screeners/REQUEST_TOPIC_LANDING';
const TOPIC_LANDING_RESPONSE = '@@screeners/TOPIC_LANDING_RESPONSE';

export default {
    REQUEST_TOPIC_LANDING,
    TOPIC_LANDING_RESPONSE,
};